// extracted by mini-css-extract-plugin
module.exports = {"VideoCard":"VideoCard_VideoCard__zDvX2"};